<template>
  <nav>
    <router-link to="/">Home</router-link>
    <router-link to="/diversity"
      >Diversity and Inclusion<i class="icon-down-open"></i
    ></router-link>
    <router-link to="/leadership">Leadership</router-link>
    <router-link to="/photos">Photos</router-link>
    <router-link to="/contact">Contact</router-link>
  </nav>
</template>

<style lang="scss" scoped>
@import url("../assets/fonts.css");

nav {
  background-color: #525252;
  display: block;
  // float: right;
  position: absolute;
  top: 240px;
  width: 100%;
  padding: 20px;
  margin: 0;

  a {
    font-family: "Smudge Stick";
    font-weight: 500;
    color: #fff;
    text-transform: uppercase;
    padding: 0 2px 0 4px;
    margin: 0 2em;
    text-decoration: none;
    letter-spacing: 2px;
    font-size: 18px;
    text-align: center;
    position: relative;
    display: inline-block;
    box-sizing: border-box;

    &::before {
      content: "";
      position: absolute;
      bottom: -8.3px;
      width: 0;
      height: 4px;
      margin: 5px 0 0;
      transition: all 0.75s ease;
      opacity: 0;
      background-color: #fff;
      display: inline-block;
    }

    &::after {
      content: "\e801";
      font-family: "icons";
      font-size: 16px;
      color: #fff;
      position: absolute;
      bottom: -15px;
      left: 0;
      opacity: 0;
      transition: all 0.75s ease;
    }

    &:hover {
      &::before {
        opacity: 1;
        width: 100%;
      }

      &::after {
        opacity: 1;
        left: 98%;
      }
    }

    &.router-link-exact-active.router-link-active {
      &::before {
        opacity: 1;
        width: 100%;
        background-color: #ff6600;
      }

      &::after {
        opacity: 1;
        left: 98%;
        color: #ff6600;
      }
    }
  }
}
</style>
<script>
export default {
  name: "navBar",
};
</script>
